export enum VesselProcessingAction {
  Unknown = 0,
  Update = 1,
  Upload = 2,
}
